const $win = $(window);

function swapImage($ele) {
  $ele.each(function() {
    const $this = $(this);
    const dataMobile = $this.data('mobile');
    const dataMobileAlt = $this.data('mobile-alt');
    const dataDesktop = $this.data('desktop');
    const dataDesktopAlt = $this.data('desktop-alt');

    if ($this.has('img').length) {
      $this.find('img').attr({
        src: $win.width() < 768 ? dataMobile : dataDesktop,
        alt: $win.width() < 768 ? dataMobileAlt : dataDesktopAlt
      });
    } else {
      $this.css({
        'background-image': `url(${$win.width() < 768 ? dataMobile : dataDesktop})`
      });
    }
  });
}

module.exports = {
  swapImage
};



// WEBPACK FOOTER //
// ../assets/js/swap-image.js